
import fetchCatalog from "@/mixins/fetchCatalog";

import { mapGetters } from 'vuex'
export default {
  mixins: [fetchCatalog],
	props: {
		pageTitle: String
	},
	computed: {
		...mapGetters({
			benefitsCredit: 'benefits/benefitsCredit',
			benefitsSlider_buyout: 'benefits/benefitsSlider_buyout'
		}),
	},
}
